import { Layout } from 'antd'
import React from 'react'
import { Outlet } from 'react-router-dom'
import PublicSider from '../Sider/PublicSider'
import { Color } from '../../../Common/Color'
import ComputerPublicHeader from '../Header/Computer/ComputerPublicHeader'

export default function ComputerSiderLayout () {
  return (
    <Layout style={{ backgroundColor: Color.white }} >
      <ComputerPublicHeader />
      <Layout style={{ backgroundColor: Color.white, maxHeight: '80%' }}>
        <PublicSider />
        <Layout.Content style={{ overflowY: 'scroll', backgroundColor: Color.white }}>
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
